import { Box, Button, IconButton, Typography } from '@mui/material';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { theme } from '@store';

type PatientCreatedToastProps = {
  closeToast?: () => void;
  goToPatient: () => void;
};

export const PatientCreatedToast: React.FC<PatientCreatedToastProps> = ({
  closeToast,
  goToPatient,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '8px',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '0.75rem' }}>
        <CheckCircleIcon htmlColor={theme.palette.common.white} />
        <Typography
          sx={{
            color: theme.palette.common.white,
            fontSize: '1rem',
          }}
        >
          You added a new patient!
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Button
          onClick={goToPatient}
          variant='text'
          sx={{
            color: theme.palette.common.white,
            fontSize: '0.8rem',
          }}
        >
          OPEN PATIENT DETAILS
        </Button>
        <IconButton
          sx={{
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '8px',
            position: 'relative',
            p: '6px',
          }}
          onClick={closeToast}
        >
          <CloseIcon fontSize='small' htmlColor={theme.palette.common.white} />
        </IconButton>
      </Box>
    </Box>
  );
};
